import React from "react";

export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  function goToPage(newPage) {
    if (newPage < 1 || newPage > totalPages) return;
    onPageChange(newPage);
  }

  return (
    <div className="flex items-center justify-center gap-4 mt-6">
      <button
        onClick={() => goToPage(page - 1)}
        disabled={page === 1}
        className="px-4 py-2 rounded-lg border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>

      <div className="px-5 py-2 rounded-full border border-gray-300 bg-white shadow-sm">
        <span>Page </span>
        <span className="font-bold">{page}</span>
        <span> of </span>
        <span className="font-bold">{totalPages}</span>
      </div>

      <button
        onClick={() => goToPage(page + 1)}
        disabled={page === totalPages}
        className="px-4 py-2 rounded-lg border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </div>
  );
}